export default __webpack_public_path__ + "static/media/sfUSDC.f08e02b1.svg";